var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtensionOfStay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2174 11.6087C20.2174 11.8861 20.2042 12.1605 20.1786 12.4312C19.7351 11.9876 19.216 11.6197 18.6421 11.3485C18.5052 7.58199 15.4087 4.57056 11.6087 4.57056C7.72164 4.57056 4.57056 7.72164 4.57056 11.6087C4.57056 15.4087 7.58199 18.5052 11.3485 18.6421C11.6197 19.216 11.9876 19.7351 12.4312 20.1786C12.1605 20.2042 11.8861 20.2174 11.6087 20.2174C6.85425 20.2174 3 16.3631 3 11.6087C3 6.85425 6.85425 3 11.6087 3C16.3631 3 20.2174 6.85425 20.2174 11.6087Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3894 11.5142L13.0489 11.8949C12.6122 12.2178 12.2252 12.604 11.9016 13.0399L11.2291 12.6516C11.0932 12.5731 10.9897 12.4601 10.9234 12.3299C10.8242 12.1764 10.8242 11.9724 10.8242 11.9724V6.91151C10.8242 6.47929 11.1746 6.12891 11.6068 6.12891C12.0391 6.12891 12.3894 6.4793 12.3894 6.91151V11.5142Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1862 16.0765C14.4918 15.7709 14.9874 15.7709 15.293 16.0765L15.7947 16.5783L17.281 15.092C17.5867 14.7864 18.0821 14.7864 18.3878 15.092C18.6934 15.3977 18.6934 15.8932 18.3878 16.1988L16.3998 18.1868C16.3322 18.2544 16.2553 18.3071 16.1732 18.3448C15.8735 18.5201 15.4821 18.4792 15.2251 18.2221L14.1862 17.1833C13.8806 16.8777 13.8806 16.3821 14.1862 16.0765Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.305 20.9997C18.8984 20.9997 21.0007 18.8974 21.0007 16.3041C21.0007 13.7107 18.8984 11.6084 16.305 11.6084C13.7117 11.6084 11.6094 13.7107 11.6094 16.3041C11.6094 18.8974 13.7117 20.9997 16.305 20.9997ZM16.305 19.4487C14.5683 19.4487 13.1604 18.0407 13.1604 16.3041C13.1604 14.5674 14.5683 13.1595 16.305 13.1595C18.0417 13.1595 19.4496 14.5674 19.4496 16.3041C19.4496 18.0407 18.0417 19.4487 16.305 19.4487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensionOfStay);
export default __webpack_public_path__ + "static/media/extension_of_stay.1741f9e47fed624b1ee386b55b81a2ec.svg";
export { ForwardRef as ReactComponent };